<template>
    <client-page>
        <sub-visual sh="Product" bg="/images/sub/visual/sv5.jpg" />

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Product</h2>
                </div>

                <v-tabs :value="tab" grow show-arrows center-active class="v-tab--primary">
                    <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/product/${value}`">
                        <span>{{ text }}</span>
                    </v-tab>
                </v-tabs>
            </v-container>
        </section>

        <section class="section section--last pt-0">
            <v-tabs-items :value="tab" touchless>
                <!-- analyzer-package -->
                <analyzer-package />
                <!-- cems-aqms -->
                <cems-aqms />
                <!-- liquid-analyzer -->
                <liquid-analyzer />
                <!-- sampling -->
                <sampling />
                <!-- corrosion-monitoring -->
                <corrosion-monitoring />
            </v-tabs-items>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import AnalyzerPackage from "@/pages/client/en/sub/product/AnalyzerPackage.vue";
import CemsAqms from "@/pages/client/en/sub/product/CemsAqms.vue";
import LiquidAnalyzer from "@/pages/client/en/sub/product/LiquidAnalyzer.vue";
import Sampling from "@/pages/client/en/sub/product/Sampling.vue";
import CorrosionMonitoring from "@/pages/client/en/sub/product/CorrosionMonitoring.vue";
import { Product_TABS } from "@/assets/variables";
const tabs = Object.values(Product_TABS);

export default {
    components: {
        ClientPage,
        SubVisual,
        AnalyzerPackage,
        CemsAqms,
        LiquidAnalyzer,
        Sampling,
        CorrosionMonitoring,
    },
    props: {
        tab: { type: String, default: Product_TABS.Analyzer.value },
    },
    data() {
        return {
            tabs,
        };
    },
    mounted() {
        this.syncPath();
    },
    methods: {
        syncPath() {
            const path = `/product/${this.tab}`;
            if (this.$route.path !== path) this.$router.replace(path);
        },
    },
};
</script>

<style lang="scss" scoped></style>
